import React from 'react';
import PropTypes from 'prop-types';
import { Translate, I18n } from 'react-redux-i18n';
import Modal from '../Modal';
import './sso-password-modal.scss';

class SsoPasswordModal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      copied: false,
    };
    this.toggleVisible = this.toggleVisible.bind(this);
    this.copyPassword = this.copyPassword.bind(this);
  }

  toggleVisible() {
    this.setState(state => ({ visible: !state.visible }));
  }

  copyPassword() {
    const { password } = this.props;
    if (!password) {
      return;
    }
    const onCopied = () => {
      this.setState({ copied: true });
      window.setTimeout(() => this.setState({ copied: false }), 2000);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(password).then(onCopied).catch(() => {});
      return;
    }
    const input = document.createElement('textarea');
    input.value = password;
    document.body.appendChild(input);
    input.select();
    try {
      document.execCommand('copy');
      onCopied();
    } catch (err) {
      // ignore
    }
    document.body.removeChild(input);
  }

  render() {
    const { show, close, email, password } = this.props;
    const { visible, copied } = this.state;

    return (
      <Modal
        show={show}
        close={close}
        hideClose
        dialogClassName="rts-sso-password-modal"
        id="modal-ssoPassword"
      >
        <div className="rts-sso-password">
          <h2 className="rts-sso-password__title">
            <Translate value="auth.ssoPassword.title" />
          </h2>
          <p className="rts-sso-password__text">
            <Translate value="auth.ssoPassword.intro" />
          </p>
          <p className="rts-sso-password__text">
            <Translate value="auth.ssoPassword.minecraft" />
          </p>
          <p className="rts-sso-password__text rts-sso-password__text--muted">
            <Translate value="auth.ssoPassword.emailed" email={email} />
          </p>

          <div className="rts-sso-password__box">
            <span className="rts-sso-password__label">
              <Translate value="auth.ssoPassword.login" />
            </span>
            <div className="rts-sso-password__value">{email}</div>
            <span className="rts-sso-password__label">
              <Translate value="auth.ssoPassword.password" />
            </span>
            <div className="rts-sso-password__value rts-sso-password__value--secret">
              {visible ? password : '••••••••••••'}
            </div>
            <div className="rts-sso-password__actions">
              <button
                type="button"
                className="rts-sso-password__btn rts-sso-password__btn--ghost"
                onClick={this.toggleVisible}
              >
                {visible
                  ? I18n.t('auth.ssoPassword.hide')
                  : I18n.t('auth.ssoPassword.show')}
              </button>
              <button
                type="button"
                className="rts-sso-password__btn"
                onClick={this.copyPassword}
              >
                {copied
                  ? I18n.t('auth.ssoPassword.copied')
                  : I18n.t('auth.ssoPassword.copy')}
              </button>
            </div>
          </div>

          <p className="rts-sso-password__text rts-sso-password__text--muted">
            <Translate value="auth.ssoPassword.reset" />
          </p>

          <button
            type="button"
            className="rts-sso-password__close"
            onClick={close}
          >
            <Translate value="auth.ssoPassword.close" />
          </button>
        </div>
      </Modal>
    );
  }
}

SsoPasswordModal.propTypes = {
  show: PropTypes.bool,
  close: PropTypes.func.isRequired,
  email: PropTypes.string,
  password: PropTypes.string,
};

export default SsoPasswordModal;
